import { Container } from "react-bootstrap";
const Navbar: React.FC = () => {
    return(
        <Container className="navbar d-flex justify-content-center font-weight-bold"><h1>My Library</h1></Container>
    )
};
export default Navbar;
